import { Box, type BoxProps } from '@mui/material'

import { color } from '@/v2/design-system/tokens'

/**
 * Superficie base para bloques de inteligencia (filas de señal/tema/
 * evidencia) — deliberadamente MÁS sutil que una Card (sin sombra, borde
 * casi invisible) para no reproducir el "card syndrome" (sección 9): sirve
 * para agrupar sin gritar "soy una tarjeta".
 */
export function IntelligenceSurface({ sx, ...props }: BoxProps) {
  return (
    <Box
      sx={{
        borderRadius: 2,
        border: `1px solid ${color.border}`,
        bgcolor: color.surfaceSubtle,
        px: 2,
        py: 1.5,
        ...sx,
      }}
      {...props}
    />
  )
}
